export const a11yConfig = {};
